var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7975 22.351L11.8675 22.391L11.8955 22.407C12.0065 22.467 12.1307 22.4985 12.257 22.4985C12.3832 22.4985 12.5074 22.467 12.6185 22.407L12.6465 22.392L12.7175 22.351C13.1086 22.1191 13.4902 21.8716 13.8615 21.609C14.8226 20.9305 15.7205 20.1667 16.5445 19.327C18.4885 17.337 20.5075 14.347 20.5075 10.5C20.5075 8.31196 19.6383 6.21354 18.0911 4.66637C16.5439 3.11919 14.4455 2.25 12.2575 2.25C10.0694 2.25 7.97102 3.11919 6.42385 4.66637C4.87667 6.21354 4.00748 8.31196 4.00748 10.5C4.00748 14.346 6.02748 17.337 7.97048 19.327C8.79412 20.1667 9.69175 20.9304 10.6525 21.609C11.024 21.8716 11.406 22.1191 11.7975 22.351ZM12.2575 13.5C13.0531 13.5 13.8162 13.1839 14.3788 12.6213C14.9414 12.0587 15.2575 11.2956 15.2575 10.5C15.2575 9.70435 14.9414 8.94129 14.3788 8.37868C13.8162 7.81607 13.0531 7.5 12.2575 7.5C11.4618 7.5 10.6988 7.81607 10.1362 8.37868C9.57355 8.94129 9.25748 9.70435 9.25748 10.5C9.25748 11.2956 9.57355 12.0587 10.1362 12.6213C10.6988 13.1839 11.4618 13.5 12.2575 13.5Z",
    fill: "#FF782C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.543a28f7c513bcb2ff7efc60f38bea13.svg";
export { ForwardRef as ReactComponent };